export const sleep = function (time) {
  if (time === void 0) {
    time = 0;
  }
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
};
export const delayedRetryable = async function (task, retries, delay) {
  if (retries === void 0) {
    retries = 3;
  }
  if (delay === void 0) {
    delay = 500;
  }
  let error;
  for (let i = 0; i <= retries; i++) {
    try {
      const result = await task();
      if (result) {
        return result;
      }
    } catch (e) {
      error = e;
    }
    await sleep(delay);
  }
  return Promise.reject(error);
};
//# sourceMappingURL=delayed-retryable.js.map